module.exports = __webpack_public_path__ + "static/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/examples/shared/favicon/favicon.ico
// module id = 513
// module chunks = 0